(function(){

var ENTRY_WIDTH  = 145;
var ENTRY_HEIGHT = 70;

G.HighscorePanelLeaderboard = function(config) {
  // imports
  var WaitingGroup = G.Leaderboard.LeaderboardWaitingGroup;

  Phaser.Group.call(this, game);

  this._RT_PADDING = 10;

  this._data = null;

  this._config = G.Utils.clone(config);

  this._brush = game.make.image(0, 0);

  this._avatarAlphaMask = game.make.image(0, 0, 'leaderboard', 'highscore-avatar-alphaMask');
  this._txt = new G.Text(0, 0, ' ', {});
  this._rt = game.make.renderTexture(602, ENTRY_HEIGHT);

  this.add(game.make.image(0, 0, this._rt));

  this.onDestroy.add(function() {
    this._txt.destroy();
    this._rt.destroy(true);
  }, this);

  this._waitingGroup = new WaitingGroup(
    301, 35,
    {
      maxWidth: 400,
      maxHeight: 50,
      errorText: OMT.language.getText("Leaderboards currently unavailable") + "\n" +OMT.language.getText("Will be back soon!"),
      errorStyle: {
        style: "font-blue",
        fontSize: 30,
        lineSpacing: -15,
      },
      messageTimeoutMS: 15000,
    }
  );

  this.add(this._waitingGroup);

  this._currentUserX = null;

  this.removeData();
};

G.HighscorePanelLeaderboard.prototype = Object.create(Phaser.Group.prototype);

G.HighscorePanelLeaderboard.prototype.hasData = function() {
  return Boolean(this._data);
};

G.HighscorePanelLeaderboard.prototype.removeData = function() {
  this._data = null;
  this._currentUserX = null;

  // solution for unfetched G.makeExtImage that are populating this object
  while(this.children[3]) {
    this.children[3].destroy();
  }

  this.x = 0;
  this._waitingGroup.show();

  this._rt.clear();
  this._rt.resize(602, ENTRY_HEIGHT);
};

G.HighscorePanelLeaderboard.prototype.init = function(data) {
  this._data = data;
  this._waitingGroup.hide();
  this._draw();
};

G.HighscorePanelLeaderboard.prototype._draw = function() {
  var entriesAmountToDraw = this._getEntriesAmountToDraw(this._data.length, this._config);

  var widthPx = entriesAmountToDraw * ENTRY_WIDTH;
  this._rt.resize(widthPx + this._RT_PADDING * 2, ENTRY_HEIGHT);

  this._rt.x = game.world.bounds.x;

  for (var i = 0; i < entriesAmountToDraw; i++) {
    var entryData = this._data[i];
    this._createEntry(
      this._RT_PADDING + i * ENTRY_WIDTH,
      10,
      entryData && entryData.rank || (i + 1),
      entryData
    );
  }
};

G.HighscorePanelLeaderboard.prototype._getEntriesAmountToDraw = function(dataLength, config) {
  var amount = config.entriesNr;
  if (config.allEntries) amount = Math.max(amount, dataLength);
  if (config.entriesMax) amount = Math.min(amount, config.entriesMax);
  return amount;
};

G.HighscorePanelLeaderboard.prototype.centerOnCurrent = function(width, height) {
  if (this._currentUserX !== null) {
    this.x = Math.min(0, 0.5 * width - this._currentUserX);
  }
};

G.HighscorePanelLeaderboard.prototype._createEntry = function(x, y, rank, userData) {

  G.changeTexture(this._brush, 'highscore-h-playerBg_small');
  this._rt.renderXY(this._brush, x + 10, y);

  var isCurrentUser = userData && userData.isCurrentUser;

  var that = this;
  if (userData) {
    var extAvatar = G.makeExtImage(
      x, y,
      userData.image, 'avatar_m',
      0, this, false,
      function() {
        var img = this;
        that._alphaMaskAvatar(x, y, img, isCurrentUser, rank);
        img.destroy();
      }
    );
  } else {
    G.changeTexture(this._brush, 'avatar_m');
    this._alphaMaskAvatar(x, y, this._brush, isCurrentUser, rank);
  }

  var name = userData ? userData.name : '---';

  this._txt.anchor.x = 0;
  this._txt.updateTransform();
  this._txt.fill = '#008bf9';
  this._txt.fontSize = '20px';
  G.Text.setMaxWidth(this._txt, 60);
  this._txt.setText(name);

  this._rt.renderXY(this._txt, x + 55, y + 3);

  if (userData && userData.score){
    this._txt.fill = '#008bf9';
    this._txt.fontSize = '20px';
    G.Text.setMaxWidth(this._txt, 60);
    this._txt.setText(userData.score.toString());
    this._rt.renderXY(this._txt, x + 55, y + 25);
  }

  if (isCurrentUser) this._currentUserX = x + 100;

};

G.HighscorePanelLeaderboard.prototype._alphaMaskAvatar = function(x,y,avatar, current, rank) {

  var bitmapData = game.make.bitmapData(50, 50);
  var rect = new Phaser.Rectangle(0, 0, 50, 50);

  bitmapData.alphaMask(avatar, this._avatarAlphaMask, rect, rect);

  var spriteBorder;

  if (this._config.displayPos) {
    spriteBorder = 'highscore-avatar-border_num';
  } else if (this._config.displayFullPos) {
    spriteBorder = 'highscore-avatar-border_num_full';
  } else {
    spriteBorder = 'highscore-avatar-border';
  }

  G.changeTexture(this._brush, spriteBorder);
  bitmapData.draw(this._brush, 0, 0, 50, 50);

  var img = bitmapData.addToWorld();

  this._rt.renderXY(img, x, y);
  bitmapData.destroy();
  img.destroy();

  if (current) {
    G.changeTexture(this._brush, 'highscore-avatar-userBorder');
    this._rt.renderXY(this._brush, x-5,y-5);
  }

  if (this._config.displayPos || this._config.displayFullPos) {
    this._txt.fontSize = '12px';
    this._txt.fill = "white";
    this._txt.anchor.x = 0.5;
    G.Text.setMaxWidth(this._txt, this._config.displayPos ? 17 : 48);
    this._txt.setText(rank.toString());
    var xx = this._config.displayPos ? x+10 : x+25;

    this._rt.renderXY(this._txt, xx, y+32);
  }

};

}());
